import moment from 'moment';
import React, { useEffect } from 'react'
import { useState } from 'react';
import { Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Row, Table } from 'reactstrap'
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from "primereact/inputtext";
import { cedimi } from '../../../../constant/globalConstantsTypeClients';



import * as XLSX from 'xlsx';

export const ReportBalanceAccount = (props) => {

	const {
		filter, setFilters, commercialLines, listOfClients, reportAccountBalance, loading,
		handleGetReportAccountInitBalance, handleGetReportBalanceAccount,
		initBalance, setGlobalFilter2, globalFilter2, expandedRows2, setExpandedRows2, rowExpansionTemplate2, urlClient,
		setRowMarkUp, rowMarkUp

	} = props;

	// const [rowMarkUp, setRowMarkUp] = useState([]);

	const number_format = (cantidad, decimals) => {
		cantidad += '';
		cantidad = parseFloat(cantidad.replace(/[^0-9\.]/g, ''));

		decimals = decimals || 0;

		if (isNaN(cantidad) || cantidad === 0) {
			return parseFloat(0).toFixed(decimals);
		}

		cantidad = '' + cantidad.toFixed(decimals);

		let cantidad_parts = cantidad.split('.'),
			regexp = /(\d+)(\d{3})/;

		while (regexp.test(cantidad_parts[0]))
			cantidad_parts[0] = cantidad_parts[0].replace(regexp, '$1' + ',' + '$2');

		return cantidad_parts.join('.');
	}

	useEffect(() => {

		if (initBalance?.length > 0 || reportAccountBalance?.length > 0) {
			let rowMark = [];

			rowMark = initBalance?.length > 0 ? initBalance.map((item, index) => {
				return {
					clientId: item?.clientId ?? null,
					clientName: item?.clientName ?? null,
					clientCommercialLine: item?.clientCommercialLine ?? null,
					clientCode: item?.clientCode ?? null,
					// totalIngress: item?.totalIngress ?? 0,
					// totalEgrees: item?.totalEgrees ?? 0,
					// totalPayments: item?.totalPayments ?? 0,
					totalIngress: 0,
					totalEgrees: 0,
					totalPayments: 0,
					initBalance: item?.totalBalance ?? 0,
					endingBalance: 0,
				}
			}) : [];

			reportAccountBalance?.length > 0 && reportAccountBalance.forEach(item => {
				if (item.clientId === 21) {
					debugger;
					console.log(item);
				}
				const clientIndex = rowMark?.find(client => client.clientId === item.clientId);
				if (clientIndex) {
					clientIndex.totalIngress += item.totalIngress;
					clientIndex.totalEgrees += item.totalEgrees;
					clientIndex.totalPayments += item.totalPayments;
					clientIndex.endingBalance = clientIndex.initBalance + clientIndex.totalIngress - clientIndex.totalPayments;
				}
				else {
					rowMark.push({
						clientId: item.clientId,
						clientName: item.clientName,
						clientCommercialLine: item?.clientCommercialLine ?? null,
						clientCode: item.clientCode,
						totalIngress: item.totalIngress,
						totalEgrees: item.totalEgrees,
						totalPayments: item.totalPayments,
						initBalance: 0,
						endingBalance: parseFloat((
							0 + item.totalIngress - (item.totalPayments)
						)),
					});
				}
			});

			rowMark?.length > 0 && rowMark.forEach((item) => {
				item.endingBalance = parseFloat((
					item.initBalance + item.totalIngress - (item.totalPayments)
				));
			});

			setRowMarkUp(rowMark);
		}

	}, [reportAccountBalance, initBalance]);


	// ? CONFIGURATION DATATABLE
	const headerStyle =
	{
		backgroundColor: "#1d5b83",
		color: "#fff",
		fontWeight: "bold",
		fontSize: "11px",
		borderRight: "1px solid #fff",
		borderBottom: "2px solid #fff",
	};

	const cellStyle =
	{
		fontSize: "11px",
		padding: "5px",
		textAlign: "center",
		fontFamily: "Montserrat, sans-serif",
	};

	const centerStyle =
	{
		...cellStyle,
		textAlign: "center",
		zIndex: 2, border: "1px solid #cccccc9c",
		borderCollapse: "collapse"
	};

	const filteredRows = rowMarkUp.filter((r) => {
		if (!globalFilter2) return true;
		const filterText = globalFilter2.toLowerCase();

		return (
			(r.clientName ?? "").toLowerCase().includes(filterText) ||
			(r.clientCode ?? "").toLowerCase().includes(filterText) ||
			(r.otherField ?? "").toLowerCase().includes(filterText)
		);
	});



	// ? SUMATORIAS
	const totalSum = filteredRows.reduce((acc, r) => acc + (r.initBalance ?? 0), 0);
	const creditNotesSum = filteredRows.reduce((acc, r) => acc + (r.totalIngress ?? 0), 0);
	const paidSum = filteredRows.reduce((acc, r) => acc + (r.totalPayments ?? 0), 0);
	const pendingSum = filteredRows.reduce((acc, r) => acc + (r.totalEgrees ?? 0), 0);
	const pendingSum2 = filteredRows.reduce((acc, r) => acc + (r.endingBalance ?? 0), 0);

	const footerStyle = {
		backgroundColor: "#000",
		color: "#fff",
		fontWeight: "bold",
		textAlign: "center",
		fontSize: "0.75rem",
		padding: "4px",
	};



	return (
		<>
			<Row className='p-3'>
				<Col sm="12" md="12" lg="12" className='p-l-0 p-r-0' >
					<Card style={{ textAlign: "left" }} className="height-equal pricingtable pt-0 pb-0 pr-0 pl-0">
						<CardBody className='p-2' >
							<div className='text-left'>
								<p style={{ fontSize: "10px" }} className='f-w-600'  >Mostrando - {reportAccountBalance?.length} resultados</p>
							</div>
							<br />
							<DataTable
								value={filteredRows}
								loading={loading}
								paginator
								rows={10}
								rowsPerPageOptions={[10, 20, 50, 100, 150, 200]}
								className="data-table"
								stripedRows
								responsiveLayout="scroll"
								emptyMessage="No hay coincidencias con la búsqueda."
								expandedRows={expandedRows2}
								onRowToggle={(e) => setExpandedRows2(e.data)}
							>
								<Column
									header="#"
									body={(_, { rowIndex }) => rowIndex + 1}
									footer=""
									headerStyle={headerStyle}
									style={centerStyle}
								/>
								<Column
									field="clientName"
									header="Cliente"
									footer=""
									headerStyle={headerStyle}
									style={centerStyle}
									sortable
								/>
								<Column
									field="clientCommercialLine"
									header="Razón social"
									footer="Totales:"
									headerStyle={headerStyle}
									style={centerStyle}
									footerStyle={footerStyle}
									sortable
								/>
								<Column
									field="initBalance"
									header={
										<div className="labeltheadInvoice" style={{ border: "1px solid #ccc", padding: "5px", textAlign: 'center' }}>
											Saldo Inicial
											<br />
											<span>
												{
													urlClient === cedimi ?
														"2025-05-01 -  " + moment(filter.dateStart).subtract(1, 'days').format('YYYY-MM-DD')
														:
														"2024-01-01 - " + moment(filter.dateStart).subtract(1, 'days').format('YYYY-MM-DD')
												}
											</span>
										</div>
									}
									footer={`$${number_format(totalSum, 2)}`}
									headerStyle={headerStyle}
									style={centerStyle}
									footerStyle={footerStyle}
									sortable
								/>
								<Column
									field="totalIngress"
									header="Cargos"
									footer={`$${number_format(creditNotesSum, 2)}`}
									headerStyle={headerStyle}
									style={centerStyle}
									footerStyle={footerStyle}
									sortable
								/>
								<Column
									field="totalPayments"
									header="Abonos"
									footer={`$${number_format(paidSum, 2)}`}
									headerStyle={headerStyle}
									style={centerStyle}
									footerStyle={footerStyle}
									sortable
								/>
								<Column
									field="totalEgrees"
									header="Desc/Dev"
									footer={`$${number_format(pendingSum, 2)}`}
									headerStyle={headerStyle}
									style={centerStyle}
									footerStyle={footerStyle}
									sortable
								/>
								<Column
									field="endingBalance"
									header={
										<div
											className="labeltheadInvoice"
											style={{
												border: "1px solid #ccc",
												padding: "5px",
												textAlign: "center",
											}}
										>
											Saldo Final
											<br />
											<span>
												al {moment(filter.dateEnd).format("YYYY-MM-DD")}
											</span>
										</div>
									}
									footer={`$${number_format(pendingSum2, 2)}`}
									headerStyle={headerStyle}
									style={centerStyle}
									footerStyle={footerStyle}
									sortable
								/>
							</DataTable>



						</CardBody>
					</Card>
				</Col>
			</Row>
		</>
	)
}
